export const prefersReducedMotion = (
  matchMedia: typeof window.matchMedia | undefined = window.matchMedia,
) =>
  Boolean(
    matchMedia?.("(prefers-reduced-motion: reduce)")?.matches,
  );

export const focusGlobalChatMessageTarget = (
  target: HTMLElement,
  options: {
    reducedMotion?: boolean;
  } = {},
) => {
  target.scrollIntoView({
    behavior: options.reducedMotion ? "auto" : "smooth",
    block: "center",
  });
  target.focus({ preventScroll: true });
};
